import { ReactNode } from "react";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "src/styles/container/index.scss";

interface ContainerProps {
  title?: string;
  hideTitle?: boolean;
  extra?: ReactNode;
  children?: ReactNode;
  hasGoBack?: boolean;
  padding?: "sm" | "md" | "lg" | "xl" | "none";
}

export const Container = ({
  hideTitle = false,
  hasGoBack = false,
  extra,
  children,
  title,
  padding = "md",
}: ContainerProps) => {
  const containerClass = `container-copy container--padding-${padding}`;

  return (
    <div className={containerClass}>
      {(title || extra) && (
        <div className="container-copy__header">
          <h3 className="container-copy__header__title">
            {title || hideTitle}
          </h3>

          <div className="container-copy__header__actions">
            {extra}
            {hasGoBack && <BackButton />}
          </div>
        </div>
      )}

      <div className="container-copy__content">{children}</div>
    </div>
  );
};

function BackButton() {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Button
      onClick={handleGoBack}
      icon={<ArrowLeftOutlined />}
      size="middle"
      danger
      className="back-button"
    >
      Orqaga
    </Button>
  );
}
